export const CONFIRM_RENAME_FIELD = 'confirm-rename-field';
export const CONFIRM_RENAME_ALL = 'confirm-rename-all';
export const CONFIRM_DELETE_FIELD = 'confirm-delete-field';
export const CONFIRM_DELETE_ALL = 'confirm-delete-all';
